import type { FaireProductEntity } from "../../entity_types/product";

export const p_69cxscyjmr: FaireProductEntity = {
  token: "p_69cxscyjmr",
  type: "product",
  name: "Super Spa Set | Sea Glass, Self-Care, Easter, Mother's Day",
  brandToken: "b_197fd05f",
  brandName: "Pinch Provisions",
  imageUrl:
    "https://cdn.faire.com/fastly/12f2c613475c3b45fa3983f1ca1202ac6a33624a0470a69dfb4b5fbdc57263aa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6b9e60053b0ce66519310a627897812994853b63e296efc94aa4f79345e051c5.jpeg",
    "https://cdn.faire.com/fastly/4217d3641464c061a5c7a1627547894d70864c82aacf02e1342f9426745884d0.jpeg",
    "https://cdn.faire.com/fastly/936d673ffef92b3a63875c1c503a52c9f31a705f3c6f768de26ccbc1ae40559d.png",
  ],
  priceDollars: 27.39,
  description:
    "The Super Spa Set by Pinch Provisions features an timeless sea glass pattern in a soft, feminine palette that will thrive in any wellness assortment. Thoughtfully packed in a nostalgic ivory jelly tote with a coordinating drawstring bag and scarf twill, this deluxe set is a ready-to-gift “self-carryall” your customers will love to give (and get).\n\nEach set includes 8 premium spa essentials for the ultimate at-home pampering session: full-size ivory ice roller, silky coordinating sleep mask, gua sha, exfoliating mitt, acetate hair clip, lavender shower steamer, scalp massager, and silky coordinating scrunchie.\n\nWith eye-catching packaging and high perceived value, this kit is a standout for beauty assortments as well as fall and holiday gifting displays.\n\nPlease note: This product is not available in Australia.",
  tags: [],
  msrpDollars: 54.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:37.216Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
